const hydratedInfographics = new WeakSet<HTMLElement>()

export function hydrateInfographicStripes(
  container: Document | Element = document
): void {
  const infographics = container.querySelectorAll<HTMLElement>(
    '.vssl-stripe--infographic'
  )

  infographics.forEach((infographicEl) => {
    if (hydratedInfographics.has(infographicEl)) return
    hydratedInfographics.add(infographicEl)

    const enlargener = infographicEl.querySelector<HTMLElement>(
      '.vssl-stripe--infographic--enlarge'
    )
    const collapser = infographicEl.querySelector<HTMLElement>(
      '.vssl-stripe--infographic--collapse'
    )

    if (!enlargener || !collapser) return

    function onInfographicKeyup(e: KeyboardEvent): void {
      if (e.key === 'Escape') {
        onCollapse()
      }
    }

    function onEnlarge(): void {
      infographicEl.setAttribute('data-is-enlarged', 'true')
      document.documentElement.classList.add('vssl-scroll-lock')
      document.body.addEventListener('keyup', onInfographicKeyup)
    }

    function onCollapse(): void {
      infographicEl.removeAttribute('data-is-enlarged')
      document.documentElement.classList.remove('vssl-scroll-lock')
      document.body.removeEventListener('keyup', onInfographicKeyup)
    }

    enlargener.addEventListener('click', onEnlarge)
    collapser.addEventListener('click', onCollapse)
  })
}
